<div [ngClass]="'form-editor'">
    <dx-check-box [attr.id]="'input-' + element.ElementID" class="single-check-edit" [enableThreeStateBehavior]="false" [value]="currentValue"
                  [rtlEnabled]="labelLeft ? true : false" [text]="labelEmbedded? element.DisplayName : ''" (onValueChanged)="valueChanged($event)" [disabled]="inputFormGroup.get('value')?.disabled"
                  [(isValid)]="renderingInformation.validationInformation.valid"
                  [(validationError)]="renderingInformation.validationInformation.validationMessage">
    </dx-check-box>
</div>
